import React, { Component } from 'react';
import "./Resume.css";

class BeeGaTech extends Component {
    render() {
        return (
            <div className="BeeGaTech">
                        <h2 className="text-center">BEE Georgia Institute of Technology</h2>
                        </div> // End of  <div className="BeeGaTech"> 
        );
    }
} 

export default BeeGaTech;




// WEBPACK FOOTER //
// ./src/components/Resume/BeeGaTech.js